import { Newsletter } from '@/components/sections/Newsletter';
import { resolveImagePath } from '@/utils/imageMap';

export function Footer() {
  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'Who We Are', href: '/who-we-are' },
    { name: 'Our Famous Bean Supper', href: '/our-famous-bean-supper' },
    { name: "Valentine's Day Bake Sale", href: '/valentines-day-bake-sale' },
    { name: 'Dedicated Leadership Team', href: '/dedicated-leadership-teams' },
    { name: 'Giving', href: '/offering' },
    { name: 'Visit Our Facebook Page!', href: 'https://www.facebook.com/pridescornerucc/?view_public_for=132510883513049' },
  ];

  const paymentMethods = [
    { name: 'Cash App', src: resolveImagePath('/images/payment-methods/cashapp.svg') },
    { name: 'Apple Pay', src: resolveImagePath('/images/payment-methods/applepay.svg') },
    { name: 'Google Pay', src: resolveImagePath('/images/payment-methods/googlepay.svg') },
    { name: 'Visa', src: resolveImagePath('/images/payment-methods/visa.svg') },
    { name: 'Mastercard', src: resolveImagePath('/images/payment-methods/mastercard.svg') },
    { name: 'American Express', src: resolveImagePath('/images/payment-methods/americanexpress.svg') },
    { name: 'Discover', src: resolveImagePath('/images/payment-methods/discover.svg') },
    { name: 'JCB', src: resolveImagePath('/images/payment-methods/jcb.svg') },
  ];

  return (
    <footer className="bg-primary-slate text-white py-12">
      <div className="max-w-6xl mx-auto px-4">
        {/* Main footer content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-8">
          {/* Left side - Church info and navigation */}
          <div>
            <h3 className="text-xl font-bold mb-6">Prides Corner Community Church</h3>
            
            <nav className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-slate-300 hover:text-white transition-colors duration-200 text-sm"
                  target={link.href.startsWith('http') ? '_blank' : undefined}
                  rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          {/* Right side - Newsletter */}
          <div>
            <Newsletter />
          </div>
        </div>

        {/* Bottom section - Payment methods and copyright */}
        <div className="border-t border-slate-600 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            {/* Payment methods */}
            <div className="flex items-center gap-3">
              <span className="text-sm text-slate-300">We accept:</span>
              <div className="flex items-center gap-2">
                {paymentMethods.map((method) => (
                  <img
                    key={method.name}
                    src={method.src}
                    alt={method.name}
                    className="h-6 w-auto"
                  />
                ))}
              </div>
            </div>

            {/* Copyright */}
            <div className="text-sm text-slate-300">
              © 2025
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}